export const TOO_MANY_OTP_REQUESTS_ERROR_MESSAGE =
  'Too many OTP requests. Please try again later'
export const TOO_MANY_REQUEST_FROM_SAME_IP_ERROR_MESSAGE =
  'Too many request from same IP.'
